import LabelContentController from "../../output/labels/labels/label-content-controller.js";

class DomLabelContentController {
    setContent(label, content) {
        label.domElement.innerText = content || "";
    }
}

export default DomLabelContentController;
